export const APP_PATH = '/app';
export const NOTES_PATH = `${APP_PATH}/notes`;
export const PLATFORM_MODERATOR_PATH = `${APP_PATH}/platform-moderator`;
export const USER_PATH = `${APP_PATH}/user`;
export const ME_PATH = `${APP_PATH}/me`;
